import { create } from 'zustand';
import { CustomAlertModel } from '../model/custom.alert.model';

export interface CustomAlertState {
    alert: CustomAlertModel | null,
}

export interface CustomAlertAction {
    handleCustomAlert: (alert: CustomAlertModel | null) => void
}
export const CusttomAlertController = create<CustomAlertState & CustomAlertAction>()(
    (set) => ({
        alert: null,
        handleCustomAlert: (alert: CustomAlertModel | null) => {
            set(() => ({ alert: alert }));
        }
    })
);

export default CusttomAlertController;